import { render, staticRenderFns } from "./educational.vue?vue&type=template&id=25e6f2e6&"
import script from "./educational.vue?vue&type=script&lang=js&"
export * from "./educational.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports